import type { UseQueryOptions } from "react-query";
import { useQuery } from "react-query";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { SpaceGroup } from "@/react/types/SpaceGroup";
import type { ApiError } from "@circle-react/config/CustomErrors";
import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";

export const useFetchSpaceGroup = ({
  id,
  options = {},
}: {
  id: string;
  options?: Omit<
    UseQueryOptions<SpaceGroup, ApiError, SpaceGroup, string[]>,
    "queryKey" | "queryFn"
  >;
}) =>
  useQuery(
    ["space-group", id],
    () => reactQueryGet<SpaceGroup>(internalApi.spaceGroups.show({ id })),
    {
      enabled: !!id,
      ...options,
    },
  );
